import type { MainNavigationGroupedBlock } from '@ps/web-martech-cms-types/SiteHeader';
import classNames from 'clsx';
import { useCallback } from 'react';
import type { NavLinkProps } from 'react-router-dom';

import { CMSResolverLink } from '@swf/cms';

import styles from './SideMenuPrototype4.scss';
import Icon from './components/Icon';

interface SideMenuProps {
  items: MainNavigationGroupedBlock[];
  className?: string;
}

const SideMenuPrototype4: React.FC<SideMenuProps> = ({ items, className }) => {
  const isActive = useCallback(
    (url?: string): NavLinkProps['isActive'] =>
      (_, { pathname }) =>
        url ? pathname.startsWith(url) : false,
    []
  );

  return (
    <div className={classNames(styles.container, className)}>
      {items.map((group) => (
        <ul className={styles.list}>
          {group.group?.map((item) => (
            <li key={item.url} className={classNames(styles.menuItem)}>
              <CMSResolverLink
                isActive={isActive(item.url)}
                activeClassName={styles.active}
                showTitle
                customIcon={<Icon icon={item.icon} />}
                {...item}
              />
            </li>
          ))}
        </ul>
      ))}
    </div>
  );
};
export default SideMenuPrototype4;
